import script from "./VDiagram.vue?vue&type=script&lang=ts&setup=true"
export * from "./VDiagram.vue?vue&type=script&lang=ts&setup=true"

import "./VDiagram.vue?vue&type=style&index=0&id=6ff97e12&lang=sass"

const __exports__ = script;

export default __exports__